import { referralSummarySchema, type ReferralSummaryResponse } from '../../../shared/api/contracts/referralSchemas';
import { requestWithAuthRetry } from '../../auth/api/authenticatedRequest';

const REFERRAL_SUMMARY_ENDPOINT = '/api/v1/referrals/me';

export async function fetchReferralSummary(): Promise<ReferralSummaryResponse> {
  const response = await requestWithAuthRetry<unknown>('GET', REFERRAL_SUMMARY_ENDPOINT);
  return referralSummarySchema.parse(response);
}
